import * as React from 'react';
import './BeachFilterNav.scss'
import { NavLink } from 'react-router-dom';
import { getHierarchiesPath } from '../../utils';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMars,
  faTimes,
  faTransgender,
  faVenus
} from '@fortawesome/free-solid-svg-icons';
import { bindActionCreators, Dispatch } from 'redux';
import { setGenderFilter } from '../../filter-nav/reducer';
import { useLocation } from 'react-router-dom';
import { BeachRootState } from '../..';
import { Gender } from '../../../../shared/common/api';

const mapStateToProps = (state: BeachRootState) => {
  return {
    associations: state.tickerState.associations,
    hierarchies: state.tickerState.hierarchies,
    gender: state.filterNav.gender
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  setGenderFilter,
}, dispatch)

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>


const BeachFilterNav = ((props: Props) => {
  const {
    setGenderFilter,
    gender,
    hierarchies
  } = props
  let location = useLocation()
  const activePathName = location.pathname

  const selectFavorites = () => {
    setGenderFilter(undefined)
  }

  const onGenderChange = (newGender: Gender) => {
    if (newGender === gender) {
      setGenderFilter(undefined)
    } else {
      setGenderFilter(newGender)
    }
  }

  const onReset = () => {
    setGenderFilter(undefined)
  }

  return <div className="FilterNav">

      <div className="gender-nav">
          <label className="container">
            <FontAwesomeIcon icon={faVenus} />
            <input type="checkbox"
              checked={gender === 'FEMALE'}
              onChange={() => onGenderChange('FEMALE')} />
            <span className="checkmark"></span>
          </label>
          <label className="container">
            <FontAwesomeIcon icon={faMars} />
            <input type="checkbox"
              checked={gender === 'MALE'}
              onChange={() => onGenderChange('MALE')} />
            <span className="checkmark"></span>
          </label>
          <label className="container">
            <FontAwesomeIcon icon={faTransgender} />
            <input type="checkbox"
              checked={gender === 'MIXED'}
              onChange={() => onGenderChange('MIXED')} />
            <span className="checkmark"></span>
          </label>
      </div>

    {hierarchies.map(hs => {
      return activePathName !== getHierarchiesPath(hs.id)
        ? <NavLink
          key={hs.id}
          to={getHierarchiesPath(hs.id)}
          className={(navData) => navData.isActive ? "selected checkboxLink" : "checkboxLink" }>
          {hs.name}
        </NavLink>
        : <NavLink key="reset-matchseries" className={(navData) => !navData.isActive ? "selected checkboxLink" : "checkboxLink" } to={'/'}>
            {hs.name}
          </NavLink>
    })}
    <NavLink key="fav" className={_ => activePathName === '/favorites' ? "selected checkboxLink" : "checkboxLink" } onClick={selectFavorites} to={activePathName !== '/favorites' ? '/favorites' : ''}>Favoriten</NavLink>
    <NavLink key="reset" className="reset" onClick={() => onReset()} to={'/'}><FontAwesomeIcon icon={faTimes}/>Filter zurücksetzen</NavLink>
  </div>
})

export default connect(mapStateToProps, mapDispatchToProps)(BeachFilterNav)
